import { filterInput } from './filter';

export async function askAI(prompt) {
  const { isValid, response } = filterInput(prompt);
  
  if (!isValid) {
    return response;
  }

  try {
    const response = await fetch("https://models.github.ai/inference/chat/completions", {
      method: "POST",
      headers: {
        Authorization: "Bearer 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", // REPLACE in prod
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "xai/grok-3-mini",
        messages: [
          { 
            role: "system", 
            content: "You are an AI assistant specializing in solar energy, solar products, and related services. Only respond to queries about solar panels, energy systems, product details, owner contacts, or general solar information. Politely decline to answer unrelated or inappropriate questions." 
          },
          { role: "user", content: prompt },
        ],
        temperature: 0.8,
        top_p: 1,
      }),
    });

    const data = await response.json();

    if (data?.choices?.[0]?.message?.content) {
      return data.choices[0].message.content.trim();
    } else {
      console.warn("Unexpected API response", data);
      return "No response from AI.";
    }

  } catch (err) {
    console.error("AI Error:", err);
    return "Something went wrong.";
  }
}